<div [style.opacity]="active ? 1 : 0" [style.width.%]="shown" class="bar"></div>
